<div class="sidebar">
     <h3 class="sidebar-heading">
          Recent Interview Codes
     </h3>

     <!-- Search input -->
     <div class="sidebar-search">
          <span class="material-icons sidebar-search-icon">search</span>
          <input type="text" class="sidebar-search-input" placeholder="Search codes, names, clients..."
               [(ngModel)]="searchQuery" (input)="onSearchInput()" />
     </div>

     <div class="sidebar-list-container">
          <!-- Skeleton loading -->
          <div class="sidebar-list sidebar-list-simple" *ngIf="loadingPrompts">
               <div *ngFor="let item of [1,2,3,4,5,6,7,8]; let i = index"
                    class="sidebar-simple-item skeleton-item animate-in"
                    [style.animation-delay]="i * 80 + 'ms'">
                    <div class="skeleton-code"></div>
                    <div class="skeleton-name"></div>
               </div>
          </div>
          <!-- Actual items -->
          <div class="sidebar-list sidebar-list-simple" *ngIf="!loadingPrompts">
               <div *ngFor="let prompt of displayedPrompts; let i = index"
                    class="sidebar-simple-item animate-in"
                    [style.animation-delay]="i * 50 + 'ms'"
                    [class.selected]="selectedPrompt?.id === prompt.id"
                    (click)="navigateToPrompt(prompt.id)" tabindex="0">
                    <div class="sidebar-simple-code">{{prompt.id}}</div>
                    <div class="sidebar-simple-name">{{prompt.consultantName || prompt.name}}</div>
               </div>
          </div>
     </div>

     <!-- Pagination controls -->
     <div class="sidebar-pagination" *ngIf="!loadingPrompts && totalPages > 0">
          <div class="pagination-row">
               <button type="button" class="page-btn" [disabled]="currentPage === 0" (click)="goToPage(currentPage - 1)">&lsaquo;</button>
               <span class="pagination-current">{{ currentPage + 1 }} / {{ totalPages }}</span>
               <button type="button" class="page-btn" [disabled]="currentPage >= totalPages - 1" (click)="goToPage(currentPage + 1)">&rsaquo;</button>
               <select class="pagination-select" title="Page size" [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                    <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}</option>
               </select>
          </div>
          <div class="pagination-info">
               {{ currentPage * pageSize + 1 }}&ndash;{{ currentPage * pageSize + displayedPrompts.length }} of {{ totalElements }}
          </div>
     </div>
</div>
